import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toaster: React.FC = () => {
    return (
        <ToastContainer
            draggable={false}
            closeButton={({ closeToast }) => (
                <button
                    onClick={closeToast}
                    aria-label="close toast"
                    className="Toastify__close-button"
                    type="button"
                />
            )}
        />
    );
};

export default Toaster;
